<template>
  <div class="noData"><slot>今日医生无排班信息</slot></div>
</template>
<script>
export default {
  props: {},
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.noData {
  color: #c0c4cc;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  padding: 30px 0;
}
</style>
